import React, { useState, useEffect } from 'react';
import { Form, Button, Typography } from 'antd';
import * as adminactions from "store/actions/AuthActions";
import { useNavigate, useParams } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import EmployeeFormComponent from "../../components/Employees/EmployeeForm";

const { Title } = Typography;

const EmployeeForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [form] = Form.useForm();
    const [employee, setEmployee] = useState(null);

    useEffect(() => {
        if (id) {
            loadEmployee();
        }
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const loadEmployee = async () => {
        try {
            const response = await adminactions.retrieveEmployee(id);
            if (response && !response.message) {
                setEmployee(response);
            }
        } catch (error) {
            console.error('Error loading employee:', error);
        }
    };

    const handleCancel = () => {
        navigate('/employees');
    };

    const handleSuccess = () => {
        navigate('/employees');
    };

    return (
        <div style={{ height: 'calc(100vh - 120px)', padding: '0 24px' }}>
            {/* Header */}
            <div style={{ 
                marginBottom: 20, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                paddingBottom: 16,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button 
                        type="link" 
                        icon={<LeftOutlined />} 
                        onClick={handleCancel}
                        style={{ paddingLeft: 0, marginRight: 16 }}
                    >
                        Back to Employees
                    </Button>
                    <Title level={3} style={{ margin: 0 }}>
                        {id ? 'Edit Employee' : 'Create New Employee'}
                    </Title>
                </div>
            </div>

            {/* Form Container */}
            <EmployeeFormComponent
                instance={employee}
                form={form}
                reload={handleSuccess}
                onCancel={handleCancel}
            />
        </div>
    );
};

export default EmployeeForm;